import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openCreditBoxModal }  from '../modules/active_modal';
import { creditActionAccept, creditActionDecline } from '../modules/credit_accept_state';
import { setCreditViewDefault, setCreditViewAccept, setCreditViewDecline } from '../modules/credit_view';

class CreditActions extends Component {

  constructor(props) {
    super(props);
  }

  handleCreditAccept(){
    this.props.dispatch( creditActionAccept());
  }

  render() {
    let {dispatch}            = this.props;
    let oCreditAction         = '';
    let iCreditTotal          = '';
    let fCreditPrice          = 0.00;
    let fCreditsPrice         = 0.00;
    let bAreCreditsAvailable  = true;
    let iDaysLeftToRespond    = '';
    let oActiveAcceptError = this.props.creditAcceptState === 'error' ?
      (<p className="errorMessage">
        We were unable to process your credit card.
        Please review your card on file or add another payment method in your Account.
      </p>) : (<div></div>);

    let bButtonDisabled = this.props.creditAcceptState === 'pending' ? true : false;

    if ( this.props.customer && this.props.customer.current_cycle ) {
      iCreditTotal          = this.props.customer.credit_total;
      fCreditPrice          = this.props.customer.current_cycle.credit_price;
      bAreCreditsAvailable  = this.props.customer.current_cycle.active;
      iDaysLeftToRespond    = this.props.customer.current_cycle.days_left_to_respond;

      switch ( this.props.creditView ){
        case 'default' :
          let sMessage   = ( iDaysLeftToRespond === 1 )
              ? 'You have 1 day left to claim your Member Credits this month.'
              : 'You have ' + iDaysLeftToRespond + ' days left to claim your Member Credits this month.';
          oCreditAction = (
            <div className="actions-wrapper">
              <h4 className="alt2">New Credits Available!</h4>
              <p>{sMessage}</p>
              <button className="btn-primary fat" onClick={() => dispatch( setCreditViewAccept() )}>Buy Credits</button>
              <button className="btn-primary fat" onClick={() => dispatch( setCreditViewDecline() )}>Skip Credits</button>
              <div className="help-link" onClick={() => dispatch( openCreditBoxModal() )}>I'll decide later.</div>
            </div>
          );
          break;
        case 'accept' :
          oCreditAction = (
              <div className="confirmation-wrapper">
                {/* save confirmation */}
                <h4 className="alt2">Buy Member Credits!</h4>
                <p>
                  Press “Buy Credits” below to purchase two credits for just ${this.props.one_credit} each.
                  Member Credits can be redeemed to purchase any book on the site.
                  Use your Member Credits right away, or save them to use later – either way, you’ll pay just ${this.props.one_credit} per book!
                </p>
                {oActiveAcceptError}
                <div>
                  <button className="btn-primary full-width fat"
                  disabled = {bButtonDisabled}
                  onClick  = {this.handleCreditAccept.bind( this )}
                  >
                  { this.props.creditAcceptState === 'pending' ? "Purchase Pending..." : "Buy Credits" }
                  </button>
                  <div className="help-link" onClick={() => dispatch( setCreditViewDefault() )}>Cancel</div>
                </div>
              </div>
          );
          break;
        case 'decline' :
          oCreditAction = (
            <div className="confirmation-wrapper">
              {/* skip confirmation */}
              <h4 className="alt2">Are you sure you want to skip this month?</h4>
              <p>
                Member Credits cost only ${this.props.one_credit} each, and can be used to purchase any book on the site.
                Use your Member Credits right away, or save them to use later – either way, you’ll pay just ${this.props.one_credit} per book!
              </p>
              <div>
                <h4 className="alt2">Are you sure you want to skip your member credits?</h4>
                <button className="btn-primary full-width fat"  onClick={() => dispatch( creditActionDecline() )} >Skip Credits</button>
                <div className="help-link" onClick={() => dispatch( setCreditViewDefault() )}>Go Back</div>
              </div>
            </div>
          );
          break;
        default :
          oCreditAction = (
            <div className="confirmation-wrapper">
              <div className={"modal-close"} onClick={() => dispatch( setCreditViewDefault() )}>&times;</div>
              {/* accept thank you */}
              <h4 className="alt2">Sorry...</h4>
              <p>An Error has occured</p>
            </div>
          );
        }
    }

    return oCreditAction;
  }
};

function mapStateToProps(state){
    return {
      'about_us': state.store.about_us,
      'one_credit': state.store.one_credit,
      'customer': state.customer,
      'creditView': state.creditView,
      'creditAcceptState': state.creditAcceptState
    };
}

export default connect(mapStateToProps)(CreditActions);


// WEBPACK FOOTER //
// ./src/components/CreditActions.jsx